import * as R from 'ramda'
import mixpanel from 'mixpanel-browser'

let identified = false
let initialized = false
let sessionProperties = {}
const actionsQueue = []
const defaultTrackOptions = { cb: undefined, debug: false }

const hasWindow = () => Boolean(typeof window !== 'undefined' && window.document)
const isActionName = (name, fn) => fn.toString().includes(`.${name}(`)

/* eslint-disable no-use-before-define */
// type MixPanelEnhanced = {
//   getDistinctId: GetDistinctId,
//   getEncodedSuperProps: GetEncodedSuperProps,
//   getRenderSide: GetRenderSide,
//   getSuperProps: GetSuperProps,
//   identify: Identify,
//   init: Init,
//   isClientSide: IsClientSide,
//   register: Register,
//   registerForAppSession: RegisterForAppSession,
//   registerOnce: RegisterOnce,
//   reset: Reset,
//   track: Track
// }
/* eslint-enable no-use-before-define */

// type GetDistinctId = () => string | null
export const getDistinctId = () => (initialized)
  ? mixpanel.get_property('distinct_id')
  : null

// type GetEncodedSuperProps = () => string | null
export const getEncodedSuperProps = () => (initialized)
  ? R.pipe(JSON.stringify, encodeURIComponent)(getSuperProps())
  : null

// type GetRenderSide = () => string
export const getRenderSide = () => (hasWindow() ? 'client' : 'server')

// type GetSuperProps = () => MixpanelProps | null
export const getSuperProps = () => (initialized)
  ? mixpanel.persistence.properties()
  : null

// type Identify = (distinctID: string) => MixPanelEnhanced
export const identify = distinctID => {
  if (initialized) {
    mixpanel.identify(distinctID)
    identified = true
  } else {
    actionsQueue.push(() => mixpanel.identify(distinctID))
  }

  return mixPanelEnhanced
}

// type Init = (token: string, config?: MixpanelConfig) => MixPanelEnhanced
export const init = (token, config) => {
  if (!initialized) {
    mixpanel.init(token, config)
    initialized = true

    actionsQueue.forEach(action => {
      if (isActionName('identify', action)) {
        identified = true
      }
      action()
    })
  }

  return mixPanelEnhanced
}

// type IsClientSide = () => boolean
export const isClientSide = () => getRenderSide() === 'client'

// type Register = (superProps: MixpanelProps) => MixPanelEnhanced
export const register = superProps => {
  if (initialized) {
    mixpanel.register(superProps)
  } else {
    actionsQueue.push(() => mixpanel.register(superProps))
  }

  return mixPanelEnhanced
}

// type RegisterForAppSession = (props: MixpanelProps) => MixPanelEnhanced
export const registerForAppSession = props => {
  sessionProperties = R.merge(sessionProperties, props)

  return mixPanelEnhanced
}

// type RegisterOnce = (props: MixpanelProps) => MixPanelEnhanced
export const registerOnce = props => {
  if (initialized) {
    mixpanel.register_once(props)
  } else {
    actionsQueue.push(() => mixpanel.register_once(props))
  }

  return mixPanelEnhanced
}

// type Reset = () => MixPanelEnhanced
export const reset = () => {
  if (initialized) {
    mixpanel.reset()
  } else {
    actionsQueue.push(() => mixpanel.reset())
  }

  return mixPanelEnhanced
}

// type TrackOptions = { debug: ?boolean, cb?: ?() => void }
// type Track = (event: string, properties: MixpanelProps, options: ?TrackOptions) => MixPanelEnhanced | void
export const track = (event, properties, options) => {
  if (initialized && identified) {
    const allProperties = R.merge(sessionProperties, properties)
    const { debug, cb } = R.merge(defaultTrackOptions, options)

    if (debug) {
      console.log('sending to Mixpanel', event, allProperties)
    }

    mixpanel.track(event, allProperties, cb)
  } else {
    actionsQueue.push(() => mixPanelEnhanced.track(event, properties, options))
  }

  return mixPanelEnhanced
}

const mixPanelEnhanced = {
  getDistinctId,
  getEncodedSuperProps,
  getRenderSide,
  getSuperProps,
  identify,
  init,
  isClientSide,
  register,
  registerForAppSession,
  registerOnce,
  reset,
  track
}

export default mixPanelEnhanced
